module.exports = __webpack_public_path__ + "static/booth-man-e62b06aa4c7092a2debc3d4f6f55bac0.png";